import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import type SearchConstituent from '@/types/api/SearchConstituent';
import { formatCurrencyWithDecimals } from '@/utils/currency';
import ColumnMaxMinWidthClasses from '../constants/ColumnMaxMinWidthClasses';

const thisYearDonationsColumn = {
  columnKey: ConstituentSearchColumn.THIS_YEAR_DONATIONS,
  headerName: 'DONOR_CONTRIBUTION_CY',
  TableCellProps: {
    className: ColumnMaxMinWidthClasses,
  },
  render: (constituent: SearchConstituent) =>
    constituent.thisYearDonations
      ? formatCurrencyWithDecimals(constituent.thisYearDonations, true)
      : null,
};

export default thisYearDonationsColumn;
